export const SALE_STEP_CONFIG_DOMAIN = "stepSaleConfig/";
export const GET_STEP_SALE_CONFIGURATION = SALE_STEP_CONFIG_DOMAIN + "getStepSaleConfiguration";
export const CLEAR_STEP_SALE_CONFIG = SALE_STEP_CONFIG_DOMAIN + "clearStepSaleConfig";
